var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHitIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2129_643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1203 6.0351C16.0352 6.11162 15.9162 6.15571 15.791 6.15707H12.7431V12.2781C12.7431 12.5067 12.6822 12.7607 12.4384 12.7607H7.56183C7.25258 12.7306 7.00429 12.534 6.95226 12.2781V6.15707H4.20922C3.95674 6.1543 3.75477 5.98152 3.7581 5.77112C3.75973 5.66679 3.81264 5.56762 3.90447 5.49669L9.69535 0.772511C9.86027 0.632257 10.1304 0.629924 10.2987 0.767357C10.3008 0.769059 10.3029 0.770761 10.3049 0.772511L16.0958 5.49669C16.281 5.63971 16.2919 5.88074 16.1203 6.0351Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.559 13.5232H12.4356C12.688 13.5232 12.8927 13.6938 12.8927 13.9042C12.8927 14.1146 12.688 14.2852 12.4356 14.2852H7.559C7.30651 14.2852 7.10181 14.1146 7.10181 13.9042C7.10181 13.6938 7.30651 13.5232 7.559 13.5232Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.559 15.0466H12.4356C12.688 15.0466 12.8927 15.2172 12.8927 15.4276C12.8927 15.638 12.688 15.8086 12.4356 15.8086H7.559C7.30651 15.8086 7.10181 15.638 7.10181 15.4276C7.10181 15.2172 7.30651 15.0466 7.559 15.0466Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.559 16.571H12.4356C12.688 16.571 12.8927 16.7416 12.8927 16.952C12.8927 17.1624 12.688 17.333 12.4356 17.333H7.559C7.30651 17.333 7.10181 17.1624 7.10181 16.952C7.10181 16.7416 7.30651 16.571 7.559 16.571Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2129_643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.6667,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 17.333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitIcon);
export default __webpack_public_path__ + "static/media/hit-icon.e0e7613fc33c965f032532ba837c4b01.svg";
export { ForwardRef as ReactComponent };